import React from 'react';
import { Card } from "react-bootstrap";
import face_wagner_tamas from "../../assets/img/face_wagner_tamas.png";
import ShowMoreText from "react-show-more-text";
import proj_aperiodic_traffic_light from "../../assets/img/proj_aperiodic_traffic_light.png";

const Tamas_Wagner_aperiodic = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_aperiodic_traffic_light} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_wagner_tamas}
              /* this will be the text on the banner */
              alt="Generation of an aperiodic signal light program using artificial intelligence methods"
            />{" "}
            <p className="text7">Tamás Wágner</p>
            <br />
            <p className="text8">
              PhD student{" "}
            </p>
            <p className="text8">BME Traffic Lab</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Aperiodic traffic light phase plans are designed to manage traffic more efficiently and 
            flexibly, where phase plans are not linked to a predefined time interval/period. This 
            topic aims to develop a new methodology that uses artificial intelligence based tools 
            and methods to optimise the sequencing of different phases to adapt to dynamic changes 
            in traffic. Particular attention should be paid to ensuring adequate time windows between 
            green periods to allow safe clearance of intersections. The research could result in an 
            algorithm or prototype that could contribute to increasing the efficiency and flexibility 
            of traffic management systems. The task is both theoretically and practically challenging, 
            making it ideal for those interested in artificial intelligence, algorithm development and 
            traffic management.
            

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Tamas_Wagner_aperiodic;